export default function tabs( containerClass ) {
	const DISPLAY_FLEX = "flex";
	const DISPLAY_NONE = "none";

	let container = document.querySelectorAll( containerClass );

	container.forEach( ( cont ) => {

		const tabLinks = cont.querySelectorAll( ".tablinks" );
		const tabContents = cont.querySelectorAll( ".tabcontent" );

		function hideAllContents() {
			tabContents.forEach( ( contentPanel ) => {
				contentPanel.style.display = DISPLAY_NONE;
			} );
		}

		// init: hide all contents and deactivate tabs, then show the first panel
		// tabLinks.forEach((tab) => {
		// 	tab.classList.remove("active");
		// });

		// click handler: show only the content matching data-tab and hide others
		tabLinks.forEach( ( tab ) => {
			tab.addEventListener( "click", () => {
				const targetId = tab.getAttribute( "data-tab" );
				if ( !targetId ) {
					return;
				}

				// hide all contents
				hideAllContents();

				// deactivate all tabs
				tabLinks.forEach( ( t ) => t.classList.remove( "active" ) );

				// activate clicked tab
				tab.classList.add( "active" );

				// show matching content
				const panel = document.getElementById( targetId );
				if ( panel ) {
					panel.style.display = DISPLAY_FLEX;
				}
			} );
		} );
	} );
}